export const Nodata = () => {
  return (
    <div className="h-[440px] unique:h-[100px] flex items-center justify-center flex-col">
      <span className="text-[16px] text-white font-poppinsBold text-center">
        There are no events today
      </span>
      <span className="text-[14px] text-white text-center">
        Come back tomorrow or pick another sport
      </span>
    </div>
  );
};
